import { type PortableTextComponentProps } from '@portabletext/react'

interface HorizontalRuleValue {
  color?: string
}

const HorizontalRule = ({
  value,
}: PortableTextComponentProps<HorizontalRuleValue>) => {
  return <hr className={`bg-${value.color ?? 'current'}`} />
}

export default HorizontalRule
